import { Button, Divider, Drawer, Input, notification } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getDecodedToken } from "../../../utils/localStorage";
import { applyPharmaCode, getPediaDoctorDetails } from "../service";
import arrowLeft from "./../../../assets/images/arrow-left.svg";
import checkMark from "./../../../assets/images/check-mark.svg";
import close from "./../../../assets/images/close.svg";
import "./../../onBoarding/OnBoarding.css";

const Refer = () => {

    const navigate = useNavigate();
    const [skip, setSkip] = useState(false);
    const [verified, setVerified] = useState(false);
    const tokenData: any = getDecodedToken();
    const doctorDetails: any = tokenData?.user || {};

    const getDoctorDetails = async () => {
        const res: any = await getPediaDoctorDetails(doctorDetails?.mobileNumber);
        if (res?.status === 200) {
            if (res?.data?.body?.access_code.toString().startsWith("MED") || res?.data?.body?.access_code.toString().startsWith("ZY")) {
                setVerified(true);
                setReferralCode(res?.data?.body?.access_code);
            }
        }
    };

    useEffect(() => {
        const url = new URL(window.location.href);
        const queryParams = url.searchParams;

        queryParams.forEach((value, key) => {
            if (key === 'skip') {
                setSkip(true);
            }
            if (key === 'verified') {
                setVerified(true);
            }
            if (key === 'code') {
                setReferralCode(value);
            }
        });
        getDoctorDetails();
    }, []);



    const [referralCode, setReferralCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [showDrawer, setShowDrawer] = useState(false);
    const backBtnHandler = () => {
        if (skip) {
            navigate("/");
        } else {
            navigate("/account");
        }
    };

    const changeHandler = (e: any) => {
        setReferralCode(e.target.value?.toString().toUpperCase());
    };

    const continueBtnHandler = async () => {
        setLoading(true);
        //call referal code api here
        const payload = { mbl_no: doctorDetails?.mobileNumber, access_code: referralCode };
        const res = await applyPharmaCode(payload);
        if (res?.status === 200) {
            setLoading(false);
            if (res?.data?.status === "200") {
                notification.success({
                    duration: 5,
                    message: res?.data?.message
                });
                if (skip) {
                    navigate("/geo", { state: { promoCode: referralCode } });
                } else {
                    setVerified(true);
                    navigate("/");
                }
            } else if (res?.data?.status === "400") {
                notification.error({
                    duration: 5,
                    message: res?.data?.message
                });
            }
        }
    }
    const skipBtnHandler = async () => {
        navigate("/");
    }
    return (<>
        <div className="flex flex-col justify-between h-full">
            <div className="flex flex-col items-start p-6">
                {!skip && <img
                    className="me-0"
                    height={22}
                    width={22}
                    src={arrowLeft}
                    alt="Youtube"
                    onClick={backBtnHandler}
                />}
                <div className="text-left text-lg xs:text-xl xsPlus:text-2xl font-semibold pb-4 pt-4">
                    {verified ? 'Referral code verified' : 'Have any referral Code ?'}
                </div>
                <div className="w-full text-left">
                    Pharma Referral Code {!verified && <span className="text-red-500">*</span>}
                    <Input
                        placeholder="Enter referral code"
                        onChange={changeHandler}
                        value={referralCode}
                        name="referralCode"
                        autoFocus={true}
                        maxLength={8}
                        size="large"
                        suffix={verified ? <img src={checkMark} alt="check" /> : ""}
                        disabled={verified}
                        autoCorrect="off"
                        className={verified ? "refer-disable" : ""}
                        spellCheck={false}
                        autoComplete="off"
                    />
                    {!verified && <span className={'mt-1 text-sm color-[#5A6774]'}>What is referral code? <b><u onClick={() => setShowDrawer(true)}>Know more</u></b></span>}
                </div>

            </div>
            <div className="w-full absolute bottom-6 left-0">
                {!verified && <div className="flex flex-col items-center max-w-[1280px] w-full">
                    <Divider />
                    <Button
                        type="primary"
                        className="w-[85%] h-14 rounded-2xl bg-[#4B4AD5] p-5 text-lg font-medium"
                        onClick={continueBtnHandler}
                        disabled={!(referralCode.length === 8)}
                        loading={loading}
                    >
                        {skip ? 'Continue' : 'Verify'}
                    </Button>
                    {skip && <Button
                        type="primary"
                        className="w-[85%] h-14 mt-2 rounded-2xl p-5 text-lg font-medium text-indigo-600 bg-white whitespace-nowrap border border-indigo-600 border-solid"
                        onClick={skipBtnHandler}
                    >
                        Skip
                    </Button>}
                </div>}
            </div>
        </div>
        <Drawer
            placement="bottom"
            onClose={() => setShowDrawer(false)}
            closeIcon={false}
            open={showDrawer}
            height="auto"
            className="rounded-t-2xl overflow-hidden"
            style={{ maxWidth: "1280px", margin: "auto" }}
        >
            <div className="flex flex-col h-full">
                <div className="flex justify-between items-center">
                    <div className="font-semibold text-lg">
                        Pharma Referral Code
                    </div>
                    <img src={close} alt="close" onClick={() => setShowDrawer(false)} />
                </div>
            </div>
            <section className="flex gap-5 mt-6 w-full text-base font-medium tracking-normal leading-loose ">
                <div>
                    <span>A Pharma Referral Code is provided by your Pharma sponsor to unlock exclusive benefits.
                        Contact your sponsor or representative if you don&apos;t have one.
                    </span><br /><br />
                    <span><b>What happens if I skip this step?</b></span><br /><span>You can always enter your referral code later from your profile settings under the "Referral code" section.</span>
                </div>
            </section>
        </Drawer>
    </>);

};

export default Refer;